import { createFileRoute } from "@tanstack/react-router";
import { Brain, UserPlus, Wand2 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import aiImg from "/lovable-uploads/11749302-d433-4877-9acb-ac3108b72948.webp";

export const Route = createFileRoute("/platform/ai-suite")({
  head: () => ({
    meta: [
      { title: "AI Suite — banana.cards" },
      { name: "description", content: "An AI brain for every contact, automatic enrichment, and AI tools that write, translate and score — everywhere you work." },
      { property: "og:title", content: "AI Suite — banana.cards" },
      { property: "og:description", content: "An AI brain for every contact, automatic enrichment, and AI tools that write, translate and score — everywhere you work." },
      { property: "og:image", content: aiImg },
      { property: "og:url", content: "https://banana.cards/platform/ai-suite" },
    ],
    links: [{ rel: "canonical", href: "https://banana.cards/platform/ai-suite" }],
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="AI"
      title="A chief of staff,"
      italic="for every contact."
      description="AI that remembers every conversation, enriches every contact and writes every follow-up — built into Banana, not bolted on."
      heroImage={aiImg}
      heroImageAlt="Banana.cards AI suite dashboard combining voice, drafting, enrichment and prospecting tools inside the CRM"
      features={[
        { title: "AI Brain", desc: "Your second brain for every conversation. Ask in plain English, get answers, drafts and next steps.", href: "/platform/ai", icon: Brain, bullets: ["Plain-English CRM queries", "Voice notes & summaries", "AI follow-up drafting"] },
        { title: "AI Enrichment", desc: "Auto-fill every contact with title, company, socials and signals — from a single email, scan or LinkedIn URL.", href: "/platform/ai-enrichment", icon: UserPlus, bullets: ["85% fields auto-filled", "60+ data sources", "Scheduled refresh"] },
        { title: "AI Tools", desc: "Writer, translator, summarizer, lead scorer and next-step suggester — wherever you work.", href: "/platform/ai-tools", icon: Wand2, bullets: ["12+ AI tools", "50+ languages", "Pick the model per feature"] },
      ]}
      outro={{ title: "Let AI handle the busywork.", italic: "You handle the relationships.", description: "An AI layer across capture, CRM and follow-up — opt-in, transparent, and yours." }}
    />
  );
}